import { Navigate, useParams } from "react-router";
import { BRANDING_GROUPS, DEFAULT_BRANDING_GROUP } from "@/branding/groups";
import { SettingsLayout } from "./SettingsLayout";
import { TwoFactorSettings } from "./TwoFactorSettings";

export function OrgSettingsLayout() {
  const { orgSlug } = useParams();
  const base = `/${orgSlug}/admin/settings`;

  return (
    <SettingsLayout
      tabs={[
        { to: base, label: "General", end: true },
        { to: `${base}/roles`, label: "Roles & permissions" },
        { to: `${base}/security`, label: "Security" },
        ...BRANDING_GROUPS.map(({ slug, label }) => ({ to: `${base}/${slug}`, label })),
      ]}
    />
  );
}

export function OrgBrandingRedirect() {
  const { orgSlug } = useParams();
  return <Navigate replace to={`/${orgSlug}/admin/settings/${DEFAULT_BRANDING_GROUP.slug}`} />;
}
